import { cn } from '@mlm/ui';
import { fmtCurrency } from '../lib/format';

/**
 * A signed money amount that never leans on color alone: credits read
 * emerald with a leading +, debits crimson with a leading −, both in tabular
 * figures. The caller shows the ledger `kind` word alongside, completing the
 * three-signal rule (hue + sign + word) from DESIGN.md. Pass no `direction`
 * for a neutral balance (no sign, inherits color).
 */
export function Amount({
  value,
  direction,
  currency = 'PHP',
  className,
}: {
  value: string;
  direction?: 'C' | 'D';
  currency?: string;
  className?: string;
}) {
  const credit = direction === 'C';
  const debit = direction === 'D';
  return (
    <span
      className={cn(
        'tabular-nums',
        credit && 'text-credit',
        debit && 'text-debit',
        className,
      )}
    >
      {credit ? '+' : debit ? '−' : ''}
      {fmtCurrency(value, currency)}
    </span>
  );
}
